import { Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import TripView from "./TripView";
import AdminView from "./AdminView";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/bjorn/demmevass" replace />} />
      <Route path="/admin" element={<AdminView />} />
      <Route path="/:user/:trip" element={<TripView />} />
    </Routes>
  );
}
